import React from 'react';
import { useTranslation } from 'react-i18next';
import { SelectItem as SelectItemView, Props } from '../../components/SelectItem';
import advCashIcon from './static/img/advcash.svg';

export const SelectItem: React.FC<Omit<Props, 'icon' | 'name'>> = (props) => {
  const { t } = useTranslation('toAdvCash');

  return <SelectItemView {...props} icon={advCashIcon} name={t('To AdvCash e-wallet')} />;
};
